<template>
  <v-alert
      dismissible
      variant="outlined"
      :class="($vuetify.breakpoint.mobile) ? 'alert alert-mobile' : 'alert'"
      v-if="isShow">
    <h5 class="mb-0 text-center">
      {{message}}
    </h5>
  </v-alert>
</template>

<script>
export default {
  name: 'InfoMessage',
  data() {
    return {
      isShow: false,
      message: 'We are undergoing maintenance, some features may not be functional. Thank you for your patience.'
    }
  },
  mounted() {
    console.log('maintenance mode: ', this.isShow);
    //this.isShow = process.env.VUE_APP_MAINTENANCE_MODE === 'true'
  }
}
</script>

<style scoped lang="sass">
.alert
  background-color: #fdf762 !important
  z-index: 9999
  width: 91%
  margin-right: 75px !important
  border-radius: 30px !important
  /*width: 96%*/
  /*top: 50px !important*/
  /*right: 20px*/
  /*right: 84px*/
  position: fixed
  &.alert-mobile
    top: 60px
    left: 0
    width: 100%
</style>
